import { useApiDataService } from './use-api-data-service';
import { MedPartnerService } from 'services/med-partner-service';

export const useMedPartnerService = () => useApiDataService<MedPartnerService>(MedPartnerService);
export default useMedPartnerService;
